module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 38
// module chunks = 0